import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { Step } from '../../utils/step-engine-constants';
import './mobile-skeleton.scss';

const MobileSkeletonHeader = () => {
  return (
    <div className="mobileSkeleton-header">
      <div className="mobileSkeleton-header-avatar">
        <Skeleton className="mobileSkeleton-header-avatar-circle" variant="circle" />
      </div>
      <div className="mobileSkeleton-header-box">
        <Skeleton className="mobileSkeleton-header-box-text" variant="text" />
      </div>
    </div>
  );
}

const genericMobileSkeleton = (
  <>
    <div className="mobileSkeleton">
      <MobileSkeletonHeader />
      <div className="mobileSkeleton-body">
        <Skeleton className="mobileSkeleton-body-item" variant="rect" />
      </div>
    </div>
  </>
);

const itemsMobileSelectionSkel = (
  <>
    <div className="mobileSkeleton">
      <MobileSkeletonHeader />
      <div className="mobileSkeleton-menu-list">
        <Skeleton className="mobileSkeleton-body-menu-list-item" variant="rect" />
        <Skeleton className="mobileSkeleton-body-menu-list-item" variant="rect" />
      </div>
    </div>
  </>
);

const formMobileSkeleton = (
  <>
    <div className="mobileSkeleton">
      <MobileSkeletonHeader />
      <div className="mobileSkeleton-body-form">
        <Skeleton className='mobileSkeleton-body-form-item' variant="text" />
        <Skeleton className='mobileSkeleton-body-form-item' variant="text" />
        <Skeleton className='mobileSkeleton-body-form-item' variant="text" />
        <Skeleton className='mobileSkeleton-body-form-item' variant="text" />
      </div>
    </div>
  </>
);

export const associativeSkelMobileMap = new Map<string, any>([
  ['genericMobileSkel', genericMobileSkeleton],
  [Step.EXTERNAL_REFERENCE, genericMobileSkeleton],
  [Step.COVER_SELECTION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_FAMILY, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_CREATION, formMobileSkeleton],
  [Step.DAMAGED_GOOD_USER_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_DATE, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_IMEI_VALIDATION, itemsMobileSelectionSkel],
  [Step.CLAIM_TRIGGER_NATURE, itemsMobileSelectionSkel],
  [Step.EXTERNAL_DAMAGE_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_SELECTION, itemsMobileSelectionSkel],
  [Step.CUSTOMER_INFORMATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_USER_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.CLAIM_RESULT_SELECTION, itemsMobileSelectionSkel],
  [Step.CHOOSE_DAMAGED_GOODS, itemsMobileSelectionSkel],
  [Step.CLAIM_LOCATION, genericMobileSkeleton],
  [Step.UPLOAD_DECLARATION, genericMobileSkeleton],
  [Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION, formMobileSkeleton],
  [Step.CLAIM_RESULT_FREE_ENTRY, genericMobileSkeleton],
  [Step.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_CIRCONSTANCES, genericMobileSkeleton],
  [Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION, genericMobileSkeleton],
  [Step.UPDATE_CLIENT_DETAILS, genericMobileSkeleton],
  [Step.CLIENT_DETAILS_CONFIRMATION, genericMobileSkeleton],
  [Step.DECLARATION_SUMMARY, formMobileSkeleton],
  [Step.IMPROVEMENT_QUALITY, genericMobileSkeleton],
  [Step.DECLARATION_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.CONTACT_FORM, genericMobileSkeleton],
  [Step.CONTACT_FORM, genericMobileSkeleton],
  [Step.CONFIRM_EMAIL, genericMobileSkeleton],
  [Step.NEED_HELP, genericMobileSkeleton],
  [Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.OTHER_CLAIM_TRIGGER_NATURE, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION_APPLE, itemsMobileSelectionSkel],
  [Step.DAMAGE_OBSERVED_FREE_ENTRY, itemsMobileSelectionSkel],
  [Step.STOLEN_TYPE_SELECTION, itemsMobileSelectionSkel],
  [Step.PHYSICAL_VIOLENCE_CONFORMATION, itemsMobileSelectionSkel],
  [Step.THEFT_INSURED_PERSON_ELIGIBILITY, itemsMobileSelectionSkel],
  [Step.THEFT_ADDRESS_VALIDATION, itemsMobileSelectionSkel],
  [Step.THEFT_ACCESSORIES_VALIDATION, itemsMobileSelectionSkel],
  [Step.THEFT_POLICE_REPORT_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.REMPLACEMENT_DEVICE_NEW_SIM_REQUEST, itemsMobileSelectionSkel],
  [Step.BURGLARY_DEVICE_SELECTION, itemsMobileSelectionSkel],
  [Step.THEFT_PLACE_SELECTION, formMobileSkeleton],
  [Step.CONTACT_FORM, genericMobileSkeleton],
  [Step.BURGLARY_LOCATION_ACTIVE_CONFIRMATION, genericMobileSkeleton],
  [Step.EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION, genericMobileSkeleton],
  [Step.CLANDESTINE_INTRODUCTION_PLACE_SELECTION, itemsMobileSelectionSkel],
  [Step.INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.PRODUCT_IN_HAND_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.PRODUCT_IN_BAG_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.PRODUCT_IN_POCKET_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.REFERENTIAL_ITEMS, itemsMobileSelectionSkel],
  [Step.SUPPORTING_DOCUMENTS, genericMobileSkeleton],
  [Step.CONTACT_MANAGEMENT_SERVICE, genericMobileSkeleton],
  [Step.DEADLINE_REMINDER_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.COMPLAINED_TO_MERCHANT_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.BENEFIT_TYPE_SELECTION, itemsMobileSelectionSkel],
  [Step.BENEFIT_TYPE_SELECTION_APPLE, itemsMobileSelectionSkel],
  [Step.BENEFIT_DEPOSIT_METHOD, itemsMobileSelectionSkel],
  [Step.DEVICE_PATTERN_LOCK, genericMobileSkeleton],
  [Step.REGISTERED_STATEMENT, genericMobileSkeleton],
  [Step.TRANSPORT_VOUCHER_GENERATION_VALIDATION, itemsMobileSelectionSkel],
  [Step.TRANSPORT_VOUCHER_GENERATION_INFORMATION, itemsMobileSelectionSkel],
  [Step.UPDATE_BENEFIT_ADDRESS_DETAILS, genericMobileSkeleton],
  [Step.INSTRUCTIONS_FOR_PACKING, genericMobileSkeleton],
  [Step.TRANSPORT_VOUCHER_GENERATION, genericMobileSkeleton],
  [Step.BENEFIT_INFORMATIVE_MESSAGE_DATA_SECURITY, genericMobileSkeleton],
  [Step.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT, genericMobileSkeleton],
  [Step.BENEFIT_POINT_SELECTION, genericMobileSkeleton],
  [Step.BENEFIT_CHOSEN_RELAY_POINT_VALIDATION, genericMobileSkeleton],
  [Step.INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE, genericMobileSkeleton],
  [Step.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION, genericMobileSkeleton],
  [Step.CLAIM_DECLARATION_DATE, itemsMobileSelectionSkel],
  [Step.CONCERNED_ELEMENT_SELECTION, itemsMobileSelectionSkel],
  [Step.COMPLAINED_TO_POLICE_REMINDER, genericMobileSkeleton],
  [Step.RELATIONSHIP_TO_THE_VICTIM, formMobileSkeleton],
  [Step.DAMAGED_GOOD_ACCESSORIES_SELECTION, itemsMobileSelectionSkel],
  [Step.RECOVERY_METHOD, itemsMobileSelectionSkel],
  [Step.UPDATE_RECOVERY_ADDRESS, genericMobileSkeleton],
  [Step.COMPLAINED_TO_POLICE_CONFIRMATION, itemsMobileSelectionSkel],
  [Step.OVERSEAS_DEPARTMENTS_AND_TERRITORIES_REMINDER, genericMobileSkeleton],
]);